import JassEnum from './enum';

/**
 * type buttontype
 */
export default class JassMouseButtonType extends JassEnum {}
